import ScheduleMobileCalendar from './ScheduleMobileCalendar'

export default ScheduleMobileCalendar;